<template>
  <div class="login-box">
    <div class="login-logo">
    </div>
    <div class="login-content">
      <div class="content-left">
        <div class="form-box">
          <div class="form-title">欢迎登陆<br /> 客户端</div>
          <div class="form-inputBox">
            <div>
              <i class="icon-my iconfont"></i>
            </div>
            <input
              v-model.trim="username"
              type="text"
              placeholder="账号"
            />
          </div>
          <div class="form-inputBox">
            <div>
              <i class="icon-14-01 iconfont"></i>
            </div>
            <input
              v-model.trim="password"
              type="password"
              placeholder="密码"
              @keyup.enter="login()"
            />
          </div>
          <!-- <p class="type_checked">
              <el-checkbox v-model="type">旧平台登录</el-checkbox>
          </p> -->
          <div
            class="form-btn"
            @click="login()"
          >
            登录
          </div>
          <div class="privacy-policy">
            <span @click="onLink('https://privacy.car900.com/simPrivacyPolicy.html')">《隐私政策》</span>
            <span @click="onLink('https://privacy.car900.com/simServiceAgreement.html')">《用户服务协议》</span>
          </div>
        </div>
      </div>
      <div class="content-bgone"></div>
      <div class="content-bgtwo"></div>
    </div>
    <p class="web_code">
      <!-- <img src="" style="float:left;"/> -->
      ©2015 car900.com 8gps.cn   版权所有 ICP证：
      <span @click="handleOpen">粤ICP备13042057号</span>
    </p>
  </div>
</template>


<script>
export default {
  methods: {
    onLink(url){
      window.open(url);
    },
    handleOpen() {
      window.open('https://beian.miit.gov.cn/');
    },
    login() {
      let params = {
        name: this.username,
        password: this.password,
        // type:this.type?1:0
      };

      if (params.name == "" || params.password == "") {
        this.$message({
          message: "账号或密码不能为空",
          type: "warning"
        });
        return;
      }

      this.$API.login(params).then(res => {
        this.$message({
          message: "登录成功",
          type: "success"
        });
        localStorage.setItem("LOGINUSER", JSON.stringify(res.data.obj));
        this.$store.commit("GETLOGINUSER", res.data.obj);
        const url = ['云杉','齐犇'].includes(res.data.obj.userCode) ?  '/renewManage/renewTable' : '/';
        this.$router.push(url);
      });
    }
  },
  mounted() {
    const chatTrigger = document.querySelector('.chat-trigger');
    if(chatTrigger){
      window.location.reload();
    }
  },
  data() {
    return {
      username: "",
      password: "",
      type:true,
    };
  }
};
</script>


<style lang="scss" scoped>
@import "@/public/css/mixin.scss";
.login-box {
  min-width: 1200px;
  min-height: 700px;
  background: url("../../public/img/login/loginBg.jpg");
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  .login-content {
    // width: 50%;
    // height: 50%;
    // min-width: 560px;
    // width: 564px;
    // min-height: 350px;
    position: absolute;
    right: 240px;
    top: 50%;
    transform: translateY(-50%);
    // background: #fff;
    display: flex;
    .type_checked{
        margin: 10px 0;
    }
    .content-bgone {
      width: 430px;
      position: absolute;
      height: 387px;
      top: 10px;
      left: -19px;
      background: linear-gradient(0deg, #1261da, #4252b2);
      opacity: 0.3;
      z-index: 9;
    }
    .content-bgtwo {
      width: 460px;
      position: absolute;
      height: 367px;
      top: 20px;
      left: -35px;
      background: linear-gradient(0deg, #1261da, #4252b2);
      opacity: 0.3;
      z-index: 8;
    }
    .content-left {
      width: 396px;
      height: 406px;
      z-index: 10;
      background: linear-gradient(
        0deg,
        rgba(10, 76, 176, 1),
        rgba(68, 108, 222, 1)
      );
      .form-box {
        padding-top: 26px;
        width: 60%;
        margin: auto;
        .form-btn {
          cursor: pointer;
          background: rgba(88, 132, 255, 1);
          box-shadow: 0px 4px 8px 0px rgba(15, 79, 180, 0.2);
          width: 100%;
          height: 35px;
          line-height: 35px;
          text-align: center;
          color: #fff;
          margin-top: 20px;
          font-size: 14px;
        }
        .form-inputBox {
          display: flex;
          margin-top: 40px;
          height: 35px;
          &:nth-child(3) {
            margin-top: 30px;
          }
          div {
            width: 50px;
            text-align: center;
            line-height: 35px;
            color: #fff;
            background: #5280e6;
          }
          input {
            width: 100%;
            height: auto;
            color: #fff;
            background: #2d5fcc;
            border: 1px solid #5280e6;
            @extend .inputBg;
          }
        }
        .form-title {
          font-size: 21px;
          text-align: center;
          line-height: 34px;
          font-family: PingFang-SC-Heavy;
          font-weight: 800;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    .content-right {
      width: 50%;
      background: url("../../public/img/login/logincont.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
  .login-logo {
    padding: 45px 0 0 61px;
  }
  .web_code {
    position: fixed;
    bottom: 10px;
    line-height: 36px;
    height: 36px;
    left: 0;
    width: 100%;
    color: #FFF;
    text-align: center;
    > span {
      cursor: pointer;
      color: #0595fe;
    }
  }
  .privacy-policy{
    text-align: right;
    margin-top: 15px;
    font-size: 12px;
    margin-bottom: 0;
    >span{
      cursor: pointer;
      color: #0595fe;
    }
  }
}
</style>
